import type { ITokenService, IUserStorageService } from "@/application/ports/services";
import type { IMonitoring, SentryUserContext } from "@/application/ports/IMonitoring";
import type { CurrentOrganizationContext } from "@/domain/organization";
import type { User } from "@/domain/user";

export function toSentryContext(
  user: User,
  organization: CurrentOrganizationContext | null,
): SentryUserContext {
  const fullName = [user.first_name, user.last_name].filter(Boolean).join(" ").trim();
  return {
    id: String(user.uuid ?? user.id),
    email: user.email,
    username: fullName || null,
    organization_uuid: organization?.organization_uuid ?? null,
    organization_name: organization?.organization_name ?? null,
    role: organization?.user_role?.toLowerCase() ?? null,
  };
}

export function clearAuthData(
  tokenService: ITokenService,
  userStorageService: IUserStorageService,
  monitoring: IMonitoring,
): void {
  tokenService.removeToken();
  tokenService.removeRefreshToken();
  userStorageService.removeCurrentUser();
  monitoring.clearUserContext();
}
